import * as React   from 'react'
import { render }   from 'react-dom'
import { Provider } from 'react-redux'

import CssBaseline             from '@material-ui/core/CssBaseline'
import MomentUtils             from 'material-ui-pickers/utils/moment-utils'
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider'

import {
  AppToast,
  JSSInsertionPointOverride,
  Language,
  Theme,
}                            from './contexts'
import Main                  from './Main'
import { store }             from './redux'
import registerServiceWorker from './register-service-worker'

import './global.css'

render(
  <Provider store={store}>
    <Language>
      <Theme>
        <CssBaseline>
          <JSSInsertionPointOverride>
            <AppToast>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <Main />
              </MuiPickersUtilsProvider>
            </AppToast>
          </JSSInsertionPointOverride>
        </CssBaseline>
      </Theme>
    </Language>
  </Provider>,
  document.getElementById('root') as HTMLElement,
)

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.tsx